import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function mobileAppConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_MOBILE_APP_CONFIGURATION:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MOBILE_APP_CONFIGURATION_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MOBILE_APP_CONFIGURATIONS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MOBILE_APP_CONFIGURATIONS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MOBILE_APP_CONFIGURATION:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MOBILE_APP_CONFIGURATION_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.CREATE_MOBILE_APP_COPYWRITING:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MOBILE_APP_COPYWRITING_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MOBILE_APP_COPYWRITINGS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MOBILE_APP_COPYWRITINGS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MOBILE_APP_COPYWRITING:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MOBILE_APP_COPYWRITING_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
